export default __webpack_public_path__ + "static/media/SEGURO.e30964e6.svg";